import { render, staticRenderFns } from "./FavoriteBooks.vue?vue&type=template&id=3f7bd4e0&scoped=true&"
import script from "./FavoriteBooks.vue?vue&type=script&lang=js&"
export * from "./FavoriteBooks.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteBooks.vue?vue&type=style&index=0&id=3f7bd4e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7bd4e0",
  null
  
)

export default component.exports